<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">AP Contract / UnBilled - Form 
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row>
            <b-col xl="8">
                <b-form-row>
                    <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>No. AP.UnBill</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" :disabled="!(saveEnabled)"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label class="text-right">tgl.Posting</label></b-input-group-prepend>
                        <b-form-input v-model="model.tanggal" :state="!$v.model.tanggal.$error" type="date" :disabled="!(saveEnabled)"></b-form-input>                                        
                    </b-input-group>
                    </b-col>
                </b-form-row >  
                <b-form-row>
                    <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.postgrpname" :state="!$v.model.postgroup.$error" :disabled="!(saveEnabled)"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuApGroupShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col lg="7">                            
                        <b-input-group >
                            <b-input-group-prepend><label class="text-right">Supplier/Vendor</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.vendorinfo" ></b-form-input>
                            <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuVendorShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-form-row>       
                <b-input-group>
                    <b-input-group-prepend><label >Uraian Kontrak</label></b-input-group-prepend>
                    <b-form-input v-model="model.agreement_title" :state="!$v.model.agreement_title.$error"></b-form-input>                                        
                </b-input-group>

                <b-input-group >
                    <b-input-group-prepend><label>Periode Kontrak</label></b-input-group-prepend>
                    <b-form-input v-model="model.tgl_awal" type="date" :state="!$v.model.tgl_awal.$error"></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="model.tgl_akhir" type="date" :state="!$v.model.tgl_akhir.$error"></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="5" > 
                    <b-input-group >
                        <b-input-group-prepend><label >Nilai Kontrak</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text pl-4 pr-4">{{uanguser}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="model.totkontrak" :precision="2" :state="!$v.model.totkontrak.$error" disabled></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">     
                    <b-row no-gutters>
                      <b-col cols="7">     
                        <b-input-group >
                            <b-input-group-prepend><label>Original Amount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                              <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.origincost" :precision="2" :state="!$v.model.origincost.$error"></my-number>
                        </b-input-group>
                      </b-col>
                      <b-col cols="5">     
                          <b-input-group >
                              <b-input-group-prepend><label style="font-size: smaller !important;" class="text-right">{{lblExchRate}}</label></b-input-group-prepend>
                              <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.kurstrx" ></my-number>
                              <!-- <b-input-group-prepend><span class="input-group-text pl-4 pr-4">from {{model.matauang}}</span></b-input-group-prepend> -->
                          </b-input-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" > 
                    <b-input-group >
                        <b-input-group-prepend><label >Billed/Invoice</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text pl-4 pr-4">{{uanguser}}</span></b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.ditagih" :precision="2" disabled></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><label >UnBilled Amount</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text pl-4 pr-4">{{uanguser}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="model.siskontrak" :precision="2" disabled></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-input-group>
                        <b-input-group-prepend><label >Intisasri/ringkasan</label></b-input-group-prepend>
                    <b-form-textarea :rows="5" :max-rows="15" v-model="model.intisari"  ></b-form-textarea>
                </b-input-group>


            </b-col>
            <b-col xl="4">
                <b-input-group >
                    <b-input-group>
                        <b-input-group-prepend><label >Tgl.Form SKA</label></b-input-group-prepend>
                        <b-form-input v-model="model.tglSKA" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-input-group>
                  <b-input-group >
                        <b-input-group-prepend><label >Ref. Agreement</label></b-input-group-prepend>
                      <b-form-input v-model="model.agreementInfo" @keyup.13.native="lkuSkaShow=true" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuSkaShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label >Status Kontrak</label></b-input-group-prepend>
                  <b-form-select v-model="model.dihentikan_status" :plain="true" :options="statusKontrak"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend><label>Tgl.Dihentikan</label></b-input-group-prepend>
                  <b-form-input v-model="model.dihentikan_tgl" type="date" :state="!$v.model.dihentikan_tgl.$error" :disabled="(model.dihentikan_status!=1)"></b-form-input>                                        
                </b-input-group>
                <div>Alasan dihentikan</div>
                <b-input-group >
                  <!-- <b-input-group-prepend><label class="text-right">Alasan dihentikan</label></b-input-group-prepend> -->
                  <b-form-input v-model="model.dihentikan_krn" :state="!$v.model.dihentikan_krn.$error" :disabled="(model.dihentikan_status!=1)"></b-form-input>                                        
                </b-input-group>
                <br>
                <b-input-group>
                      <b-input-group-prepend><label >UnBill DB Acc#</label></b-input-group-prepend>
                      <b-form-input v-model="model.ApUnBillDbAccInfo" placeholder="Prepaid/Asset Account" 
                      v-b-tooltip.hover title="Prepaid/Asset Account" ></b-form-input>
                      <b-input-group-append >
                      <b-btn text="Button" @click="showLkuCoa('ApUnBillDbAcc')" v-b-tooltip.hover title="Prepaid/Asset Account">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                <b-input-group>
                      <b-input-group-prepend><label >UnBill CR Acc#</label></b-input-group-prepend>
                      <b-form-input v-model="model.ApUnBillCrAccInfo" placeholder="Contract Liability Account"></b-form-input>
                      <b-input-group-append >
                      <b-btn text="Button" @click="showLkuCoa('ApUnBillCrAcc')">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                </b-input-group>
                <b-input-group>
                      <b-input-group-prepend><label >COGS/Expense Acc</label></b-input-group-prepend>
                      <b-form-input v-model="model.UnBillCogsAccInfo" placeholder="Amortized COGS Account"></b-form-input>
                      <b-input-group-append >
                      <b-btn text="Button" @click="showLkuCoa('UnBillCogsAcc')">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                </b-input-group>


            </b-col>
        </b-row>
        <!-- <b-row no-gutters>
            <b-col xl="3">
                <b-input-group >
                    <b-input-group-prepend><label >Status Kontrak</label></b-input-group-prepend>
                  <b-form-select v-model="model.dihentikan_status" :plain="true" :options="statusKontrak"></b-form-select>
                </b-input-group>
            </b-col>
            <b-col xl="3">
                <b-input-group v-if="(model.dihentikan_status==1)">
                  <b-input-group-prepend><label class="text-right">Tgl.Dihentikan</label></b-input-group-prepend>
                  <b-form-input v-model="model.dihentikan_tgl" type="date" :state="!$v.model.dihentikan_tgl.$error"></b-form-input>                                        
                </b-input-group>
            </b-col>
            <b-col xl="6">
                <b-input-group v-if="(model.dihentikan_status==1)">
                  <b-input-group-prepend><label class="text-right">Alasan dihentikan</label></b-input-group-prepend>
                  <b-form-input v-model="model.dihentikan_krn" :state="!$v.model.dihentikan_krn.$error"></b-form-input>                                        
                </b-input-group>
            </b-col>
        </b-row> -->
      <b-row class="justify-content-center mt-2">
          <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
      </b-row>
    </b-card>
    <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
    </b-modal>        
    <b-modal v-model="lkuSkaShow" size="lg" :hide-footer="true" title="List PKS/Agreement " :centered="true" :lazy="true">
        <lku-ska @click="onSelectLkuSka" ></lku-ska>
    </b-modal>        
    <b-modal v-model="lkuApGroupShow" size="lg" :hide-footer="true" title="List of AP Posting Group" :centered="true">
        <lku-appostinggrp @click="onSelectLkuApGroup"></lku-appostinggrp>
    </b-modal>        
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
        <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>     

  </div>
</template>

<style lang="scss">
    .table-wraper {
         width:100%;
         height:180px;
         overflow-x: auto;
         overflow-y: auto;
        border: 1px solid silver;
    }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuVendor from "../lookup/lkuVendor";
import lkuSka from "../lookup/lkuCpAgreement";
import lkuCoa from "../lookup/lkuCoa";
import lkuAppostinggrp from "../lookup/lkuApGroup";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import apkontrak from '../../apis/apkontrak';
import crud from "../../apis/crud";
toastr.init();

export default {
  components: { myNumber, lkuVendor, lkuSka, lkuAppostinggrp, lkuCoa},
  mixins: [validationMixin],
  validations: {
    model: {
        tanggal: { required },
        postgroup: { required },
        agreement_title: { required },
        tgl_awal: { required },
        tgl_akhir: { required },
        origincost: { required, minValue:minValue(1) },
        matauang: { required },
        kurstrx: { required, minValue:minValue(0.0001) },
        totkontrak: { required, minValue:minValue(1) },
        dihentikan_tgl: {required : (function() {
            if ((this.model.dihentikan_status || 0) != 1) {
                return true;
            } else if (!(this.model.dihentikan_tgl)){
                return false;
            } else return true;
        })},
        dihentikan_krn: {required : (function() {
            if ((this.model.dihentikan_status || 0) != 1) {
                return true;
            } else if (!(this.model.dihentikan_krn)){
                return false;
            } else return true;
        })},

    },
  },   
  data() {
    return {
      saveEnabled: true,
      horizontal: true,
      lkuApGroupShow: false,
      lkuVendorShow: false,
      lkuSkaShow: false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      coa:[],
      model: {
          Dim1Info:'',Dim2Info:'',Dim3Info:'',Dim4Info:'',Dim5Info:'',Dim6Info:'',Dim7Info:'',Dim8Info:'',Dim9Info:'',
          tanggal:'', tgl_awal: '',tgl_akhir:'',
          agreement_no:'',agreementInfo:'', agreement_title: '', totkontrak:0,
          matauang: 'IDR',intisari:'',
          vendor_id: '',postgroup:'',
          totkontrak: 0,ditagih: 0, siskontrak:0,
          ApUnBillDbAcc:'',ApUnBillCrAcc:'', UnBillCogsAcc:'',
          kurstrx: 1,dihentikan_status:0,dihentikan_tgl:null,dihentikan_krn:''
      },
      postGroups:[],
      appostgrp:{},
      agreement:{},
      totalDb:0,
      totalCr:0,
      totalRow:0,
      currency:[],
      uanguser:this.$store.state.user.matauang,
      lblExchRate:'Exchange Rate',
      billHist: {
        items: [],
        fields:[
          {
            key: "index",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "tanggal",
            label: "AP Date",
          },
          {
            key: "nomor",
            label: "AP Number",
          },
          {
            key: "nilaidpp",
            label: "Amount (Excl VAT)",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "invdate",
            label: "Invoice Date",
          },
          {
            key: "invoice",
            label: "Invoice No.",
          },
        ]        
      },
      statusKontrak :   [{ value: 0, text: 'AKTIF' }, { value: 1, text: 'DIHENTIKAN' }, { value: -1, text: 'BERAKHIR' }],
    }
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    matauang(){
      return this.model.matauang;
    },
    kurstrx(){
      return this.model.kurstrx;
    },
    origincost(){
      return this.model.origincost;
    },
  },
  watch: {  
    matauang: function (newval) {
      if (newval === this.uanguser) this.model.kurstrx = 1;
    },
    kurstrx: function (newval) {
      this.model.totkontrak = parseFloat(this.model.origincost) * parseFloat(newval || 1);
    },
    origincost: function (newval) {
      this.model.totkontrak = parseFloat(this.model.kurstrx  || 1) * parseFloat(newval);
    },

  },

  created: async function (){
     const { user } = this.$store.state;
     const [a,c,d] = await Promise.all([apkontrak.postgroup(), apkontrak.currency(), apkontrak.getcoa({ tahun: this.tahun})]) ;
     this.postGroups = a;
     this.currency = c;
     this.coa = d;


      this.lblExchRate=`Exch.Rate ${this.model.matauang} to ${this.uanguser}`;
      if (this.$route.params.kontrakKey)  {
          toastr.info('Loading Amortization Detail, please wait')
          try {
            const data = await apkontrak.detail(this.$route.params);  
            const row = data;
            // this.billHist.items = data[1];
            // console.log('  this.billHist.items = ',this.billHist.items)
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            this.model.tglSKA = row.tglSKA ? moment(row.tglSKA).format('YYYY-MM-DD') : '';
            this.model.tgl_awal = row.tgl_awal ? moment(row.tgl_awal).format('YYYY-MM-DD') : '';
            this.model.tgl_akhir = row.tgl_akhir ? moment(row.tgl_akhir).format('YYYY-MM-DD') : '';
            if (row.agreementId) {
                this.model.agreementInfo= (row.agreement_no) ? row.agreement_no : '(kosong)';
            }

            crud.detail({tablename:'channel-agreement', key: this.model.agreementId})
                .then(_selected => {
                    this.agreement = _selected;
                }).catch(err => {
                    console.log('get channel-agreement -> ', err);
                });

            // this.tanggalBerubah();
            toastr.clear;
            this.model.UnBillCogsAccInfo = row.UnBillCogsAcc;
            this.model.ApUnBillCrAccInfo = row.ApUnBillCrAcc;
            this.model.ApUnBillDbAccInfo = row.ApUnBillDbAcc;
            let _selected;
            try {
              if (row.UnBillCogsAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.UnBillCogsAcc);
                if (_selected) {
                    this.model.UnBillCogsAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
              if (row.ApUnBillCrAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.ApUnBillCrAcc);
                if (_selected) {
                  this.model.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
              if (row.ApUnBillDbAcc) {
                _selected = this.coa.find(p => p.kodeacc==row.ApUnBillDbAcc);
                if (_selected) {
                  this.model.ApUnBillDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                }
              }
            } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }                      
            }

            setTimeout(() => {
                this.$forceUpdate();              
            }, 300);

          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
         this.model.tgl_awal = moment().format('YYYY-MM-DD');
         this.model.tanggal = moment().format('YYYY-MM-DD');
      }

    this.$watch('model.UnBillCogsAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.UnBillCogsAcc === newval) && (newval)) {
            console.log(' coa diketik : ', newval);
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
            console.log(' coa ketemu : ', _selected);
                this.model.UnBillCogsAcc = _selected.kodeacc;
                this.model.UnBillCogsAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.UnBillCogsAcc);
                this.model.UnBillCogsAcc='';
                this.model.UnBillCogsAccInfo = '';
            }
          }
      }, 500);
    });            
    this.$watch('model.ApUnBillDbAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.ApUnBillDbAcc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.model.ApUnBillDbAcc = _selected.kodeacc;
                this.model.ApUnBillDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.ApUnBillDbAcc);
                this.model.ApUnBillDbAcc='';
                this.model.ApUnBillDbAccInfo = '';
            }
          }
      }, 500);
    });            
    this.$watch('model.ApUnBillCrAcc', function(newval) {
      setTimeout(() => {
          if ((this.model.ApUnBillCrAcc === newval) && (newval)) {
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
                this.model.ApUnBillCrAcc = _selected.kodeacc;
                this.model.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.ApUnBillCrAcc);
                this.model.ApUnBillCrAcc='';
                this.model.ApUnBillCrAccInfo = '';
            }
          }
      }, 500);
    });            

  },
  methods: {
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.model[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model[this.lkuCoaCaller] = _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    refresh() {
      this.$refs.table.refresh();
    },
    // tanggalBerubah: function(){
    //     const newVal=moment(this.model.tgl_awal).format('YYYY');
    //     if ( this.tahun != newVal) {
    //         this.tahun=newVal;
    //         apkontrak.getcoa({ tahun: this.tahun}).then(result => {
    //                 this.coa = result;
    //                     if  (this.coa.length==0) {
    //                         this.getCoa();
    //                     }                        
    //                 })
    //                 .catch(err => {
    //                     console.log('get COA -> ', err);
    //                 });
    //         } else if  (this.coa.length==0) {
    //             this.getCoa();
    //         }
    // },
    // getCoa: function(){
    //     this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
    //     apkontrak.getcoa({ tahun: this.tahun}).then(result => {
    //             this.coa = result;
    //         })
    //         .catch(err => {
    //             console.log('get COA -> ', err);
    //         });
    // },        
    // showLkuCoa(callerObj)
    // {
    //   this.lkuCoaShow=true;
    //   this.lkuCoaCaller=callerObj;
    // },
    // onSelectLkuCoa(_selected) {
    //     if (this.lkuCoaCaller==='debit'){
    //         this.model.dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
    //         this.model.db_kodeacc = _selected.kodeacc;
    //         this.model.db_namaacc = _selected.namaacc;
    //     } else {
    //         this.model.krAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
    //         this.model.kr_kodeacc = _selected.kodeacc;
    //         this.model.kr_namaacc = _selected.namaacc;
    //     }
    //     this.lkuCoaShow=false;
    // },
    onSelectLkuApGroup(_selected) {
        this.model.postgroup = _selected.postgrpcode.trim();
        this.model.postgrpname = _selected.postgrpname;
        this.model.useAPUnbill = _selected.useAPUnbill;
        this.appostgrp=_selected;
        this.lkuApGroupShow=false;
    },    

    onSelectLkuVendor: async function (_selected) {
        this.lkuVendorShow=false;
        this.model.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.model.ApUnBillDbAcc=_selected.ApUnBillDbAcc;
        this.model.ApUnBillCrAcc=_selected.ApUnBillCrAcc;
        this.model.UnBillCogsAcc=_selected.UnBillCogsAcc;
        if (!(this.model.postgroup)) {
            const apgroup= this.postGroups.find(d => d.value==_selected.apgroup);    
            if (apgroup) {
                this.appostgrp=apgroup;
                this.model.postgroup = _selected.apgroup;
                this.model.postgrpname = apgroup.text;
            }            
        }    
    },

    onSelectLkuSka(_selected) {
      this.lkuSkaShow=false;
      this.agreement = _selected;
      this.model.agreementId= _selected._id;
      this.model.agreement_no= _selected.agreement_no;
      this.model.agreementInfo= (_selected.agreement_no) ? _selected.agreement_no : '(kosong)';
      this.model.agreement_title= _selected.agreement_title;
      this.model.origincost= _selected.hargatotal;
      this.model.tglSKA = _selected.tglSKA ? moment(_selected.tglSKA).format('YYYY-MM-DD') : '';
      this.model.tgl_awal= moment(_selected.pks_begidate).format('YYYY-MM-DD');
      this.model.tgl_akhir= moment(_selected.pks_enddate).format('YYYY-MM-DD');
      if (_selected.vendor_id) {
            this.model.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.legalPartiesName.trim();
            this.model.vendor = _selected.vendor_code;
            this.model.vendor_id = _selected.vendor_id;
            if (_selected.ApUnBillDbAcc) this.model.ApUnBillDbAcc=_selected.ApUnBillDbAcc;
            if (_selected.ApUnBillCrAcc) this.model.ApUnBillCrAcc=_selected.ApUnBillCrAcc;
            if (_selected.UnBillCogsAcc) this.model.UnBillCogsAcc=_selected.UnBillCogsAcc;

      } else if (this.model.vendor_id) {
            crud.update({tablename:'channel-legal-parties', 
                key:_selected.legalPartiesId, 
                data:{vendor_id:this.model.vendor_id, vendor_code:this.model.vendor}
                }).catch(err => {
                    console.log('Update VENDOR channel-legal-parties error-> ', err);
                });
      }

    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.warn('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          this.saveEnabled=true;
        } else if (!(this.model.vendor_id) && !(this.agreement.vendor_id)) {
          toastr.error('Vendor must be selected.', "ERROR MESSAGE");
          let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm(`Apakah "${this.agreement.legalPartiesName}" ini adalah LEGAL PARTIES baru ?`, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
            try {
              if (!(this.agreement)) {
                toastr.error('Agreement must be selected.', "ERROR MESSAGE");
                return
              }
                const objVendor = {
                  vendor_name: this.agreement.legalPartiesName,
                  vendor_address1: (this.agreement.legalPartiesAddr || "").substring(0,150),
                  vendor_address2: (this.agreement.legalPartiesAddr || "").substring(150),
                  vendor_city: this.agreement.legalPartiesCity || "",
                  vendor_phone: this.agreement.legalPartiesTlp || "",
                  vendor_fax: this.agreement.legalPartiesFax || "",
                  npwp: this.agreement.legalPartiesNpwp || "",
                  npwp_name: this.agreement.legalPartiesNpwpName || "",
                  npwp_address1: (this.agreement.legalPartiesNpwpAddr || "").substring(0,400),
                  npwp_address2: (this.agreement.legalPartiesNpwpAddr || "").substring(400),
                  IsIndividu: 0,
                  apgroup: this.model.postgroup || "",
                  apkodeacc: this.appostgrp.ApAccount || this.model.apkodeacc || "",
                  ApUnBillCrAcc: this.appostgrp.ApUnBillCrAcc || "",
                  ApUnBillDbAcc: this.appostgrp.ApUnBillDbAcc || "",
                  UnBillCogsAcc: this.appostgrp.UnBillCogsAcc || "",
                };
              // console.log('vendor obj : ', objVendor);
              const vendor = await apkontrak.insertVendor(objVendor) ;
                this.agreement.vendor_id = vendor._id;
                this.agreement.vendor_code = vendor.vendor_code;
                this.agreement.vendor_name = vendor.vendor_name;
                this.model.vendor_id = vendor._id;
                this.model.vendor = vendor.vendor_code;
                this.model.vendor_name = vendor.vendor_name;
                this.model.vendorinfo = vendor.vendor_code.trim() + ' | ' + vendor.vendor_name.trim();
                toastr.success(`Data VENDOR untuk LEGAL PARTIES baru telah berhasil dibuat: "${this.model.vendorinfo}"`, "INFORMASI", 10000);

                crud.update({tablename:'channel-legal-parties', 
                key:this.agreement.legalPartiesId, 
                data:{vendor_id:this.model.vendor_id, vendor_code:this.model.vendor}
                }).catch(err => {
                    console.log('Update VENDOR channel-legal-parties error-> ', err);
                });

              } catch (error) {
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
              }
          }   
          this.saveEnabled=true;          
        } else {
            try {
              let data= {}
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.tgl_awal = moment(this.model.tgl_awal).format('YYYY-MM-DD');
              data.tgl_akhir = moment(this.model.tgl_akhir).format('YYYY-MM-DD');

              await apkontrak.insert(data);
              toastr.success("Complete successfully", "Save Amortization");
              this.close();
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
              this.saveEnabled=true;
            }
        }
    },
    close(){
        router.push({name:"payable.apkontrak"});
    }
  }
};
</script>
